import { render, staticRenderFns } from "./DesktopApp.vue?vue&type=template&id=3e88fc58&scoped=true"
import script from "./DesktopApp.vue?vue&type=script&lang=js"
export * from "./DesktopApp.vue?vue&type=script&lang=js"
import style0 from "./DesktopApp.vue?vue&type=style&index=0&id=3e88fc58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e88fc58",
  null
  
)

export default component.exports